enum StorageKey {
  TOKEN = '_zhk_token',
}

export default StorageKey;
